import { listTablePrefs } from 'app/constants'
import { listPools } from 'app/plugins/openstack/components/networks/dns/pools/actions'
import { poolsSelector } from 'app/plugins/openstack/components/networks/dns/pools/selectors'
import { useAppSelector } from 'app/store'
import ListContainer from 'core/containers/ListContainer'
import useListAction from 'core/hooks/useListAction'
import { createUsePrefParamsHook } from 'core/hooks/useParams'
import DataKeys from 'k8s/DataKeys'
import { pick } from 'ramda'
import React from 'react'
import { formatTimestampToLocal } from '../../../vms/helpers'

const defaultParams = {
  orderBy: 'created_at',
  orderDirection: 'desc',
}

const columns = [
  {
    key: 'name',
    label: 'Name',
  },
  // {
  //   key: 'phase',
  //   label: 'Status',
  //   CellComponent: createGridStatusCell({
  //     dataFn: (phase) => getPoolStatus(phase),
  //   }),
  // },
  // {
  //   key: 'backend',
  //   label: 'Backend',
  // },
  // {
  //   key: 'servers',
  //   label: 'Servers',
  // },
  {
    key: 'description',
    label: 'Description',
    formatFn: (description) => description || '-',
  },
  {
    key: 'created_at',
    label: 'Created',
    render: (time: string) => formatTimestampToLocal(time),
    display: false,
  },
]
const searchTargets = ['name']

const usePrefParams = createUsePrefParamsHook('DnsPools', listTablePrefs)

const PoolsListPage = () => {
  const { params, getParamsUpdater } = usePrefParams(defaultParams)

  const { loading, message, reload } = useListAction(listPools)
  const data = useAppSelector(poolsSelector)

  return (
    <>
      {/*  Commenting due to BE dependancy*/}
      {/* <AddPoolPage />
      <UpdatePoolPage /> */}
      <ListContainer<any, any>
        dataKey={DataKeys.DnsPools}
        searchTargets={searchTargets}
        uniqueIdentifier="id"
        loading={loading}
        loadingMessage={message}
        onRefresh={reload}
        data={data || []}
        columns={columns}
        //Commenting due to BE dependancy
        // addText="Add DNS Pool"
        // addUrl={routeManager.routes.openstack.createDnsResrouce.path({
        //   tab: DnsPageTabs.Pools,
        // })}
        // editUrl={(item) =>
        //   routeManager.routes.openstack.editDnsResource.path({
        //     tab: DnsPageTabs.Pools,
        //     id: item?.id,
        //   })
        // }
        getParamsUpdater={getParamsUpdater}
        // deleteAction={deletePool}
        {...pick(listTablePrefs, params)}
        disableRowSelection
      />
    </>
  )
}

export default PoolsListPage
